<template>
  <article class="minhaconta__body" v-if="loaded">
    <form @submit.prevent="submit()" class="columns" v-if="!isChangePassword">
      <dr-field
        prefix="form1"
        class="text-left"
        v-for="(field, name) in formData"
        :form.sync="formData"
        :field="field"
        :value.sync="formData[name].value"
        :validators.sync="$v.formData[name]"
        :apiErrors.sync="apiErrors[name]"
        :id="name"
        :ref="name"
        :key="'main_'+name">
      </dr-field>

      <p class="text-warning col-12 text-center" v-if="$v.$invalid && sending">
        Por favor complete o formulário corretamente
      </p>

      <span class="col-12">
        <br />

        <dr-submit
          :disabled="$v.$invalid || !formData.medicalSpecialty.value"
          :sending="sending"
          text="Salvar"
        />

        &emsp;&emsp;
        <a @click="isChangePassword = true">
          <strong>Alterar senha</strong>
        </a>
      </span>
    </form>
    <changePassword @change="isChangePassword = false" v-else />
    <br />
    <br />
    <hr />
    <br />
    <cancelAccount />
  </article>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import changePassword from './changePassword.vue'
import { formData, validations } from '@/data/formData/userDoctor'
import EventBus from '@/globals/eventBus'
import cancelAccount from '@/components/form/cancelAccount'

export default {
  name: 'DrUserForm',

  props: ['dataForm'],

  components: {
    drField,
    drSubmit,
    changePassword,
    cancelAccount
  },

  validations: {
    formData: validations
  },

  data () {
    return {
      isChangePassword: false,
      loaded: false,
      showForm: true,
      formData: formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false,
      specializationIndex: 0,
      disableCpf: false,
      isCfmValidation: true,
      specializationCourses: null
    }
  },

  computed: {
    ddi () {
      return this.formData['user.ddiContactPhone'].value
    }
  },

  watch: {
    ddi: {
      deep: false,
      immediate: false,
      handler (next, before) {
        if (next !== before) {
          const { mask } = this.formData['user.ddiContactPhone'].options
            .find((option) => option.id === next)

          this.formData['user.contactPhone'].mask = next === 'br'
            ? ['(##) ####-####', '(##) #####-####']
            : [mask]
        }
      }
    }
  },

  created () {
    this.formData['user.ddiContactPhone'].value = 'br'
  },

  mounted () {
    this.loaded = false
    this.fn_SHOW_PROGRESS()
    this.fn_FLATTEN_OBJECT(this.dataForm)
      .then((obj) => {
        for (let field in obj) {
          if (this.formData[field]) {
            this.formData[field].value = obj[field]

            if (field === 'user.cpf' && obj[field]) {
              this.formData[field].disabled = true
              this.disableCpf = true
            }

            if (field === 'isAmbEspecialization' && obj[field]) {
              this.formData[field].value = (obj[field] === 'false') ? 0 : 1
            }

            if (field === 'isAttendHealthInsurance' && obj[field]) {
              this.formData[field].value = (obj[field] === 'false') ? 0 : 1
            }
          }
        }

        this.formData.medicalSpecialty.options = obj.medicalSpecialties
        this.formData.medicalSpecialty.value = obj.medicalSpecialties

        if (
          this.formData.medicalSpecialty.value &&
          this.formData.medicalSpecialty.value
            .some(i => /(não|nao) registrado/gi.test(i.name))
        ) {
          delete this.formData.medicalSpecialty.tooltip
          this.getMedicalSpecialties()
            .then((medicalSpecialties) => {
              this.formData.medicalSpecialty.options = medicalSpecialties
              this.formData.medicalSpecialty.type = 'select'
              this.formData.medicalSpecialty.value = null
              this.formData.medicalSpecialty.disabled = false
              this.isCfmValidation = false
            })
        }

        this.formData['user.ddiContactPhone'].value = obj['user.ddiContactPhone']
          ? this.formData['user.ddiContactPhone'].options
            .find((option) => option.code === obj['user.ddiContactPhone'])
            .iso
          : 'br'

        this.specializationCourses = [...this.formData.specializationCourses.value]
      })
      .catch(err => console.trace(err))
      .finally(() => {
        this.loaded = true
        this.fn_HIDE_PROGRESS()
      })
  },

  methods: {
    submit () {
      this.apiErrors = this.fn_BUILD_API_ERRORS(formData)
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      this.fn_SHOW_PROGRESS()
      let data = this.fn_COPY_OBJECT(this.formData)

      data['user.contactPhone'].value = this.fn_NUMBERS_ONLY(data['user.contactPhone'].value)
      data['user.cpf'].value = this.fn_NUMBERS_ONLY(data['user.cpf'].value)

      let newArr = {}
      for (let i = this.specializationIndex; i < this.specializationIndex + data.specializationCourses.value.length; i++) {
        if (data.specializationCourses.value[i - this.specializationIndex].id) {
          delete data.specializationCourses.value[i - this.specializationIndex].id
        }
        newArr[i] = data.specializationCourses.value[i - this.specializationIndex]
      }
      data.specializationCourses.value = newArr
      if (this.disableCpf) {
        delete data['user.cpf']
      }
      delete data.crm
      data = this.fn_EXPAND_OBJECT(data)

      const cfmValidation = (
        this.dataForm['is_cfm_validation'] === 'false' ||
        this.dataForm['is_cfm_validation'] === 0 ||
        !this.dataForm['is_cfm_validation']
      ) ? 0 : 1

      data['isCfmValidation'] = !this.isCfmValidation
        ? 0
        : cfmValidation

      if (!this.isCfmValidation) {
        const name = this.formData.medicalSpecialty.options
          .find(i => i.id === data.medicalSpecialty)
          .name
        data.medicalSpecialties = [{ name }]
      }

      delete data.medicalSpecialty

      data.user.ddiContactPhone = this.formData['user.ddiContactPhone'].options
        .find((option) => option.id === data.user.ddiContactPhone)
        .code

      this.$http
        .put(
          '/doctor',
          { 'edit': data },
          this.$store.getters.getAuthHeader
        )
        .then(() => this.fn_GET_DOCTOR())
        .then((doctor) => {
          EventBus.$emit('updated-user-data', doctor)

          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Dados alterados com sucesso',
            size: 'md',
            active: true
          })
          this.$emit('updated', this.formData['user.name'].value)

          this.formData.medicalSpecialty.disabled = true
          this.formData['user.cpf'].disabled = true
          this.specializationCourses = [...this.formData.specializationCourses.value]
        })
        .catch((err) => {
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                }
                this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
              }
            )
          } else {
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        })
        .finally(() => {
          this.fn_HIDE_PROGRESS()
          this.sending = false
        })
    },

    capitalizeString (str) {
      return str.toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.substring(1))
        .join(' ')
    },

    getMedicalSpecialties () {
      return this.$http
        .get('/medical_specialty?itensPerPage=all')
        .then((res) => {
          return res.data.data
            .map((specialty) => {
              return {
                id: specialty.id,
                name: this.capitalizeString(specialty.name)
              }
            })
        })
    }
  },

  beforeRouteLeave (to, from, next) {
    const oldCourses = this.specializationCourses
      .map(item => item.name)
      .sort()

    const newCourses = this.formData.specializationCourses.value
      .map(item => item.name)
      .sort()

    const areSame = (arr1, arr2) => {
      return arr1.length === arr2.length &&
        arr1.every((item, index) => item === arr2[index])
    }

    if (areSame(oldCourses, newCourses)) {
      next()
    } else {
      this.$store.dispatch('setModalConfirm', {
        title: 'Atenção',
        body: `Você precisa confirmar as alterações
          nos cursos de especialização no botão Salvar. \n
          Deseja continuar?
        `,
        confirmText: 'Sair sem salvar',
        cancelText: 'Cancelar',
        beforeClose: (v) => {
          if (v) {
            next()
          }

          this.$store.dispatch('setModalConfirm')
        },
        size: 'md',
        active: true
      })
    }
  }
}
</script>
